import type { StateCreator } from 'zustand'
import type { AuthResponse, AuthStatus, AuthUser, Permission } from '../../types/index.js'

export interface AuthSlice {
  authReady: boolean
  authStatus: AuthStatus | null
  authUser: AuthUser | null
  authTrustedDeviceDays: number
  setAuth: (response: AuthResponse) => void
  clearAuth: () => void
  setAuthReady: (ready: boolean) => void
  hasPermission: (permission: Permission) => boolean
}

export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (set, get) => ({
  authReady: false,
  authStatus: null,
  authUser: null,
  authTrustedDeviceDays: 0,
  setAuth: response => set({
    authReady: true,
    authStatus: response.status,
    authUser: response.user,
    authTrustedDeviceDays: response.trustedDeviceDays ?? get().authTrustedDeviceDays,
  }),
  clearAuth: () => set({ authReady: true, authStatus: null, authUser: null }),
  setAuthReady: authReady => set({ authReady }),
  hasPermission: permission => get().authUser?.role === 'ADMIN' ||
    Boolean(get().authUser?.permissions.includes(permission)),
})

